import { render, staticRenderFns } from "./nutritional-row.vue?vue&type=template&id=13602bf8&"
import script from "./nutritional-row.vue?vue&type=script&lang=js&"
export * from "./nutritional-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports